(function () {
  'use strict';
  function init(root) {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    var cfg;
    try { cfg = JSON.parse(root.dataset.config); } catch (_) { return; }
    var text = cfg.strings || {};
    var base = (root.dataset.root || '/').replace(/\/?$/, '/');
    var panel = root.querySelector('.jon-nelia__panel');
    var log = root.querySelector('[data-nelia-log]');
    var input = root.querySelector('[data-nelia-input]');
    var form = root.querySelector('[data-nelia-form]');
    var chips = root.querySelector('[data-nelia-chips]');
    var send = form.querySelector('button[type="submit"]');
    var opener;
    var controller;
    var sequence = 0;
    try { sessionStorage.removeItem('jon-nelia-v1'); } catch (_) {}
    function url(path) { return base + path.replace(/^\//, ''); }
    function message(value, who) {
      var row = document.createElement('div');
      row.className = 'jon-nelia__msg jon-nelia__msg--' + (who || 'bot');
      row.textContent = value;
      log.appendChild(row);
      while (log.children.length > 30) log.firstElementChild.remove();
      log.scrollTop = log.scrollHeight;
      return row;
    }
    function link(row, label, path) {
      var anchor = document.createElement('a');
      anchor.href = url(path);
      anchor.textContent = label;
      row.appendChild(document.createElement('br'));
      row.appendChild(anchor);
    }
    function safeUrl(value) {
      try { var parsed = new URL(value, location.origin); return parsed.origin === location.origin ? parsed.href : null; } catch (_) { return null; }
    }
    function busy(value) { send.disabled = value; form.setAttribute('aria-busy', String(value)); }
    function normal(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
    function forChildren(product) {
      return (product.tags || []).some(function (tag) {
        return /^(zielgruppe[:_-](kinder|kinder-jugendliche|kinder & jugendliche)|audience[:_-](kids|children))$/.test(normal(tag));
      });
    }
    function shortcuts() {
      chips.replaceChildren();
      [text.magnesium, text.omega, text.tests, text.offers, text.shipping].forEach(function (label) {
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'jon-nelia__chip'; button.textContent = label;
        button.addEventListener('click', function () { ask(label); });
        chips.appendChild(button);
      });
    }
    function greet() { message(text.greeting); shortcuts(); }
    async function json(path, signal) {
      var response = await fetch(url(path), { credentials: 'same-origin', signal: signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('request');
      return response.json();
    }
    function products(items) {
      var row = message(text.results);
      row.classList.add('jon-nelia__msg--wrap');
      var grid = document.createElement('div'); grid.className = 'jon-nelia__products';
      items.forEach(function (product) {
        var variant = product.variants.find(function (v) { return v.available; });
        var productUrl = safeUrl(product.url || url('products/' + encodeURIComponent(product.handle)));
        if (!productUrl || !variant) return;
        var target = new URL(productUrl); target.searchParams.set('variant', variant.id);
        var card = document.createElement('a'); card.className = 'jon-nelia__product'; card.href = target.href;
        var source = product.featured_image;
        if (source) {
          var imageUrl = new URL(source, location.origin);
          if (imageUrl.protocol === 'https:') {
            imageUrl.searchParams.set('width', '240');
            var img = document.createElement('img'); img.src = imageUrl.href; img.alt = ''; img.width = 120; img.height = 120; img.loading = 'lazy'; card.appendChild(img);
          }
        }
        var title = document.createElement('strong'); title.textContent = product.title; card.appendChild(title);
        var price = document.createElement('span');
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cfg.currency || 'EUR' }).format(variant.price / 100);
        card.appendChild(price);
        var cta = document.createElement('span'); cta.textContent = text.view_product + ' →'; card.appendChild(cta);
        grid.appendChild(card);
      });
      row.appendChild(grid); log.scrollTop = log.scrollHeight;
    }
    async function ask(value) {
      var query = String(value || '').trim().slice(0, 160);
      if (!query) return;
      if (controller) controller.abort();
      var current = ++sequence;
      controller = new AbortController();
      message(query, 'user');
      var q = normal(query);
      busy(false);
      if (/atemnot|brustschmerz|notfall|vergiftung|overdose|chest pain|emergency|urgence|noodgeval|emergenza/.test(q)) {
        message(text.emergency); return;
      }
      if (/schwanger|stillzeit|medikament|blutverdunn|erkrank|diabet|schilddrus|pregnan|breastfeed|medication|enceinte|allait|zwanger|borstvoeding|gravidanza|allattamento/.test(q)) {
        message(text.personal_advice); return;
      }
      if (/versand|liefer|porto|shipping|delivery|livraison|verzend|levering|spedizion|consegna/.test(q)) {
        link(message(text.shipping_info), text.shipping, 'pages/versand'); return;
      }
      if (/rabatt|gutschein|angebot|spar|discount|offer|reduction|offre|korting|aanbied|scont|offert/.test(q)) {
        link(message(text.offer_info), text.offers, 'collections/angebote'); return;
      }
      if (/kontakt|contact|contatt|bestellung|order|commande|bestelling|ordine|retour|rucksend|zahlung|payment|paiement|betaling|pagamento|abo|subscription|abonnement/.test(q)) {
        link(message(text.contact_info), text.contact, 'pages/kontakt'); return;
      }
      if (/schmerz|beschwer|hilft|helfen|dosierung|einnehm|wie viel|mude|abnehmen|haarausfall|schlaflos|pain|symptom|dosage|dose|douleur|pijn|dolore|dimagr/.test(q)) {
        link(message(text.personal_advice), text.explore, 'pages/guide'); return;
      }
      var children = /\b(kinder|kind|kids|children|child|enfant|enfants|kinderen|bambini|bambino|baby)\b/.test(q);
      busy(true);
      var timeout = setTimeout(function () { if (current === sequence) controller.abort(); }, 12000);
      try {
        var result = await json('search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide', controller.signal);
        var matches = result.resources?.results?.products || [];
        var full = await Promise.all(matches.slice(0, 8).map(function (product) {
          return json('products/' + encodeURIComponent(product.handle) + '.js', controller.signal).catch(function () { return null; });
        }));
        if (current !== sequence) return;
        var eligible = full.filter(function (product) { return product && product.available && product.variants?.some(function (v) { return v.available; }) && (!children || forChildren(product)); });
        if (eligible.length) {
          products(eligible.slice(0, Math.min(6, cfg.products_count || 4)));
          if (children) message(text.children_note);
        } else {
          var empty = message(children ? text.no_children : text.empty);
          if (!children) link(empty, text.all_results, 'search?type=product&q=' + encodeURIComponent(query));
        }
      } catch (_) {
        if (current === sequence) message(text.error);
      } finally {
        clearTimeout(timeout);
        if (current === sequence) busy(false);
      }
    }
    function open(trigger) {
      opener = trigger || document.activeElement;
      root.classList.add('is-open', 'was-opened'); panel.hidden = false;
      root.querySelectorAll('[data-nelia-toggle]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
      if (!log.children.length) greet();
      input.focus();
    }
    function close() {
      root.classList.remove('is-open'); panel.hidden = true;
      root.querySelectorAll('[data-nelia-toggle]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      if (opener?.isConnected) opener.focus();
    }
    root.querySelectorAll('[data-nelia-toggle]').forEach(function (button) { button.addEventListener('click', function () { panel.hidden ? open(button) : close(); }); });
    root.querySelector('[data-nelia-reset]').addEventListener('click', function () {
      ++sequence; if (controller) controller.abort(); busy(false); log.replaceChildren(); greet(); input.focus();
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); var query = input.value; input.value = ''; ask(query); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) close(); });
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-open-nelia], a[href$="#nelia"]');
      if (!button) return;
      event.preventDefault(); open(button); if (button.dataset.neliaAsk) ask(button.dataset.neliaAsk);
    });
    function hash() { if (cfg.open_on_hash && location.hash === '#nelia') open(); }
    window.addEventListener('hashchange', hash); hash();
    window.jonNelia = { open: open, close: close, ask: function (value) { open(); ask(value); } };
    if (window.visualViewport) {
      function fit() {
        if (window.innerWidth > 749) { panel.style.removeProperty('height'); panel.style.removeProperty('bottom'); return; }
        if (panel.hidden) return;
        var viewport = window.visualViewport;
        panel.style.bottom = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) + 'px';
        panel.style.height = Math.max(200, Math.min(viewport.height - 12, 720)) + 'px';
      }
      window.visualViewport.addEventListener('resize', fit); input.addEventListener('focus', fit);
    }
  }
  function initAll() { document.querySelectorAll('[data-jon-nelia]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
